import React from 'react';
import {isUK} from './stack';
import {tradeSiteEnabled} from '../utils/toggles';

const UK_STRINGS = {
  currency: '£',
  eircode: 'Postcode',
  'outlet.search.placeholder': 'Search by outlet id, customer number, outlet name, Postcode...',
  'outlet.validation.customerNumber': 'Customer Unique Number',
  'outlet.validation.customerNumber.tooltip': "If you don't know your customer number please contact your Imperial Tobacco Representative",
  'outlet.validation.eircode': 'Full Store Postcode',
  'outlet.validation.eircode.tooltip': "If you don't know your Postcode please contact your Imperial Tobacco Representative",
  packsSold: 'Outers Sold',
  pointsPerPack: 'Points per outer',
  'pointsPerPack.up': 'Points per outer up to target',
  'pointsPerPack.post': 'Points per outer post target',
  'pointsPerPack.over': 'Points per outer over target',
  'pointsPerPack.before': 'Points per outer before target',
  'pointsPerPack.after': 'Points per outer after target',
  'registration.part1': 'An investment programme designed to help independent ' +
      'retailers achieve the highest standards of tobacco ' +
      'retailing and move their business forward.',
  'registration.part2': (
    <div>
        Registering for
      {' '}
      <strong>
          ignite
      </strong>
      {' '}
        is a simple process, you just need to have your store details handy.
    </div>
  ),
  'registration.disabled':
    'Registration for the ignite programme is temporarily unavailable as we are working on some improvements to the ignite website. ' +
    'Please check back soon',
  rsp: 'RRP',
  'rsp.withCurrency': 'RRP (£)',
  staffRewardSettings: 'Outlet Reward Settings',
  'staffRewardSettings.saved.success': 'Outlet Reward settings saved successfully',
  'staffRewardSettings.saved.error': 'An error occurred during save Outlet Reward settings',
  staffRewards: 'Outlet Rewards',
  'staffRewards.saved.success': 'Outlet rewards has been saved successfully',
  'staffRewards.autoRedeem': 'Auto redeem Outlet Rewards',
  'staffRewards.balance': 'Outlet Rewards Balance',
  'staffRewards.denomination': 'I would like my outlet reward vouchers sent in denominations of...',
  'staffRewards.manage': 'Manage outlet rewards',
  'staffRewards.redemption': 'OUTLET REWARD REDEMPTIONS',
  'staffRewards.redemption.menu': 'Outlet Reward Redemptions',
  'staffRewards.statement': 'Outlet Rewards Statement',
  'manualPointTransaction.note': 'Please note any points added here will be awarded ' +
      'as personal reward points and not outlet reward points.',
  'yourStore.iDontKnowEircode': 'I do not know my Postcode',
};

const UK_TRADE_SITE_STRINGS = {
  ...UK_STRINGS,
  'registration.part1': 'Registering is easy, you just need your store details handy.',
  'registration.part2': 'If you need help please speak with your ' +
      'Imperial Tobacco Representative or use the contact us link at the bottom of this page.'
};

const IRELAND_STRINGS = {
  currency: '€',
  eircode: 'Eircode',
  'outlet.search.placeholder': 'Search by outlet id, customer number, outlet name, Eircode...',
  'outlet.validation.customerNumber': 'John Player Customer Account Number',
  'outlet.validation.customerNumber.tooltip': "If you don't know your customer number please contact your John Player Representative",
  'outlet.validation.eircode': 'Eircode or Passcode',
  'outlet.validation.eircode.tooltip': "If you don't know your Eircode please contact your John Player Representative",
  packsSold: 'Packs Sold',
  pointsPerPack: 'Points per pack',
  'pointsPerPack.up': 'Points per pack up to target',
  'pointsPerPack.post': 'Points per pack post target',
  'pointsPerPack.over': 'Points per pack over to target',
  'pointsPerPack.before': 'Points per pack before target',
  'pointsPerPack.after': 'Points per pack after target',
  'registration.part1': (
    <div>
      <strong>
        ignite
      </strong>
      {' '}
      is the new home for tobacco retailers in Ireland to
      easily order products from John Player and stay up to
      date with the latest category news and legislative
      information.
    </div>
  ),
  'registration.part2': (
    <div>
      Registering for
      {' '}
      <strong>
        ignite
      </strong>
      {' '}
      is simple, all you need is your
      Customer Number and store Eircode. If you don't have
      this information, please contact your John Player
      Representative.
    </div>
  ),
  rsp: 'RSP',
  'rsp.withCurrency': 'RSP (€)',
  staffRewardSettings: 'Staff Reward Settings',
  'staffRewardSettings.saved.success': 'Staff Reward settings saved successfully',
  'staffRewardSettings.saved.error': 'An error occurred during save Staff Reward settings',
  staffRewards: 'Staff Rewards',
  'staffRewards.saved.success': 'Staff rewards has been saved successfully',
  'staffRewards.autoRedeem': 'Auto redeem Staff Rewards',
  'staffRewards.balance': 'Staff Rewards Balance',
  'staffRewards.denomination': 'I would like my staff reward vouchers sent in denominations of...',
  'staffRewards.manage': 'Manage staff rewards',
  'staffRewards.redemption': 'STAFF REWARD REDEMPTIONS',
  'staffRewards.redemption.menu': 'Staff Reward Redemptions',
  'staffRewards.statement': 'Staff Rewards Statement',
  'manualPointTransaction.note': 'Please note any points added here will be awarded ' +
                                 'as personal reward points and not staff reward points.',
  'yourStore.iDontKnowEircode': 'I do not know my Eircode',
};

const t = (identifier) => {
  if (isUK()) {
    if (tradeSiteEnabled()) {
      return UK_TRADE_SITE_STRINGS[identifier];
    }
    return UK_STRINGS[identifier];
  }
  return IRELAND_STRINGS[identifier];
};

export default t;



// WEBPACK FOOTER //
// ./src/data/translations.js